import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import router from "@/router";
import CreateBillDialog from "./CreateBillDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdminBills',
  props: {
    bills: {}
  },
  emits: ["refresh"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();


const emit = __emit;

const search = ref("");

const headers = [
  { title: "Azonosító", key: "identifier" },
  { title: "Státusz", key: "status" },
  { title: "Típus", key: "type" },
  { title: "Összeg", key: "amount", align: "end" as const },
  { title: "Foglalás elemek", key: "bookingItems" },
  { title: "Létrehozva", key: "createdAt" },
  { title: "Részletek", key: "id", align: "end" as const },
];

const STATUS_LABELS: Record<string, string> = {
  DUE: "Esedékes",
  PAID: "Fizetve",
  CANCELLED: "Törölve",
  OVERDUE: "Lejárt",
};

const STATUS_COLORS: Record<string, string> = {
  DUE: "orange",
  PAID: "green",
  CANCELLED: "grey",
  OVERDUE: "red",
};

const TYPE_LABELS: Record<string, string> = {
  ACCOMMODATION: "Szállás",
  IFA: "IFA",
};

const TYPE_COLORS: Record<string, string> = {
  ACCOMMODATION: "blue",
  IFA: "purple",
};

const statusLabel = (s: string) => STATUS_LABELS[s] ?? s;
const statusColor = (s: string) => STATUS_COLORS[s] ?? "grey";

const typeLabel = (t: string) => TYPE_LABELS[t] ?? t;
const typeColor = (t: string) => TYPE_COLORS[t] ?? "grey";

const formatAmount = (value: number | null | undefined) =>
  value == null ? "-" : `${value.toLocaleString("hu-HU")} Ft`;

const formatDate = (ts: number) => {
  if (!ts) return "-";
  return new Date(ts).toLocaleDateString("hu-HU", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const handleViewClick = (id: number) => {
  router.push(`/admin/bills/${id}`);
};

const __returned__ = { emit, search, headers, STATUS_LABELS, STATUS_COLORS, TYPE_LABELS, TYPE_COLORS, statusLabel, statusColor, typeLabel, typeColor, formatAmount, formatDate, handleViewClick, ref, get router() { return router }, CreateBillDialog }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})